module.exports = {"init":"Gitalk を読み込んでいます...","no-found-related":"%{link} に関連するものが見当たりません","please-contact":"コメントを初期化するために %{user} に連絡してください","init-issue":"イシューを初期化する","leave-a-comment":"コメントを残す","preview":"プレビュー","edit":"編集する","comment":"コメント","support-markdown":"Markdown 記法をサポートしています","login-with-github":"GitHub にログインする","first-comment-person":"最初にコメントを残しましょう!","commented":"によるコメント","load-more":"もっと見る","counts":"%{counts} つのコメント","sort-asc":"投稿順に並び替え","sort-desc":"最新順で並び替え","logout":"ログアウト","anonymous":"匿名"}


//////////////////
// WEBPACK FOOTER
// ./i18n/ja.json
// module id = 272
// module chunks = 0